import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { Button, Modal, InputNumber, message } from 'antd'
import { request } from '../../utils/http'
import custom from '../../config/custom'
import { updateDispatchById } from '../../modules/dispatch'
import _ from 'lodash'

import './index.css'

const confirm = Modal.confirm

class Timer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      start: this.props.start,
      end: this.props.end,
      time: null,
      amount: 0
    }

    this.interval = null
  }

  componentWillMount() {
    if (this.state.start && !this.props.end) {
      this.restartTimer()
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.start !== this.props.start) {
      this.setState({
        start: nextProps.start,
      }, () => {
        this.restartTimer()
      })
    }

    if (nextProps.end !== this.props.end) {
      this.setState({ end: nextProps.end })
    }
  }

  restartTimer() {
    clearInterval(this.interval)

    this.setState({
      time: moment()
    }, () => {
      this.interval = setInterval(() => {
        this.setState({
          time: this.state.time.add(1, 'second')
        })
      }, 1000)
    })
  }

  start(e) {
    e.stopPropagation()
    this.setState({ loading: true })

    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/started`)
      .then(response => {
        message.success('Tránsito iniciado')

        this.props.updateDispatchById(this.props.id)

        this.setState({
          start: moment().format('YYYY-MM-DD HH:mm:ss'),
        }, () => {
          this.restartTimer()
        })
      })
      .catch(() => {
        message.warning('No se pudo iniciar el tránsito')
      })
      .then(() => {
        this.setState({ loading: false })
      })
  }

  addToCart(supplier) {
    this.setState({ amount: 0 })

    return new Promise((resolve, reject) => {
      confirm({
        title: `Pago a ${supplier.name}`,
        content: (
          <div>
            <InputNumber
              defaultValue={0}
              onChange={value => { this.setState({ amount: value }) }}
              min={0}
              style={{ width: '100%' }}
              formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
            />
          </div>
        ),
        okText: 'Confirmar',
        cancelText: 'Cerrar',
        centered: true,
        onOk: () => {
          if (this.state.amount > 0) {
            setTimeout(() => {
              resolve()
            }, 200)
          } else {
            message.warning('El importe debe ser mayor a cero')
            return 'Error'
          }
        },
        onCancel: () => {
          this.setState({ amount: 0 }, () => {
            reject()
          })
        },
      })
    })
  }

  async finish(e) {
    e.stopPropagation()

    const dispatch = _.find(this.props.dispatches, dispatch => dispatch.id === this.props.id)

    if (dispatch.billType &&
      dispatch.supplier &&
      dispatch.supplier.name !== 'G-TRANSPORT') {
      try {
        await this.addToCart(dispatch.supplier)
      } catch (error) {
        return
      }
    }

    confirm({
      title: 'Finalizar tránsito?',
      content: 'Una vez finalizado únicamente administradores podrán editar la información del tránsito',
      okText: 'Sí',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: true,
      centered: true,
      onOk: () => {
        this.setState({ loading: true })

        request(`${custom.baseUrl}/dispatch/${this.props.id}/status/finished`, {
          params: {
            amount: this.state.amount
          }
        })
          .then(response => {
            clearInterval(this.interval)

            message.success('Tránsito finalizado')

            this.props.updateDispatchById(this.props.id)

            this.setState({
              end: moment().format('YYY-MM-DD HH:mm:ss')
            })
          })
          .catch(() => {
            message.warning('No se pudo finalizar el tránsito')
          })
          .then(() => {
            this.setState({ loading: false })
          })
      },
      onCancel: () => {
        this.setState({ loading: false })
      },
    });
  }

  render() {
    if (!this.state.start) {
      return (
        <Button
          type={'primary'}
          loading={this.state.loading}
          onClick={e => { this.start(e) }}
        >
          Iniciar tránsito
                </Button>
      )
    } else if (this.state.end) {
      return (
        <Button type={'dashed'}>
          {moment.utc(moment(this.state.end).diff(this.state.start)).format('HH:mm:ss')}
        </Button>
      )
    }

    return (
      <Button
        type={'primary'}
        className={'dispatch-item-timer'}
        loading={this.state.loading}
        onClick={e => { this.finish(e) }}
      >
        &nbsp;
                <span className={'dispatch-item-finish-label'}>
          {this.state.loading ? 'Finalizando...' : 'Finalizar tránsito'}
        </span>
        <span className={'dispatch-item-timer-label'}>
          {this.state.loading ? 'Finalizando...' : moment.utc(moment(this.state.time).diff(this.state.start)).format('HH:mm:ss')}
        </span>
      </Button>
    )
  }

}

const mapStateToProps = state => ({
  selected: state.dispatch.selected,
  dispatches: state.dispatch.items
})

const mapDispatchToProps = dispatch => bindActionCreators({
  updateDispatchById
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Timer)



// WEBPACK FOOTER //
// ./src/containers/Timer/index.js